module.exports = __webpack_public_path__ + "img/1.99fd99aa.jpg";